import React from "react";
import { Marker } from "react-map-gl";
import Icon from "../icon";

const MarkerComponent = (props) => {
  const { marker, color, onMarkerClick } = props;

  return (
    <Marker
      key={`marker ${marker.index}`}
      longitude={marker.longitude}
      latitude={marker.latitude}
    >
      <React.Fragment>
        <button onClick={() => onMarkerClick(marker.index)}>
          <Icon icon="Marker" color={color}/>
        </button>
      </React.Fragment>
    </Marker>
  );
};

export default MarkerComponent;
